import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const errorSelector = createSelector(selfSelector, (analytic) => analytic.error);

export default errorSelector;
